import React, { ReactElement } from "react";
import Content from "./Content";

export default function Paragraph(props: any): ReactElement {
  const { children, align } = props;
  return (
    <p style={{ ...(align && { textAlign: align }), marginBottom: "10px", whiteSpace: "pre-wrap" }}>
      <Content contentValue={children} />
    </p>
  );
}
